import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=6a271936&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=6a271936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a271936",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a271936')) {
      api.createRecord('6a271936', component.options)
    } else {
      api.reload('6a271936', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=6a271936&scoped=true&", function () {
      api.rerender('6a271936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/Button.vue"
export default component.exports